import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from './../../firebase/firebaseConfig';
import Layout from './Layout';
import PageTitle from '../includes/PageTitle';
import './../css/Login.css';

const AddSizeForm = () => {
  const [sizeName, setSizeName] = useState('');
  const [sizes, setSizes] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSizes = async () => {
      const sizesCollection = collection(db, "Sizes");
      const sizeSnapshot = await getDocs(sizesCollection);
      const sizeList = sizeSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setSizes(sizeList);
    };

    fetchSizes();
  }, []);

  const validateSizeName = (name) => {
    const trimmedName = name.trim();
    if (trimmedName === '') {
      return 'Size name cannot be empty.';
    }
    if (/[^a-zA-Z0-9\s]/.test(trimmedName)) {
      return 'Size name contains invalid characters.';
    }
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const validationError = validateSizeName(sizeName);
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      const newSize = await addDoc(collection(db, "Sizes"), {
        name: sizeName
      });
      alert(`Size "${sizeName}" added successfully!`);
      setSizes([...sizes, { id: newSize.id, name: sizeName }]);
      setSizeName('');
      setError('');
    } catch (e) {
      console.error("Error adding size: ", e);
      alert('Error adding size.');
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "Sizes", id));
      setSizes(sizes.filter(size => size.id !== id));
      alert('Size deleted successfully!');
    } catch (e) {
      console.error("Error deleting size: ", e);
      alert('Error deleting size.');
    }
  };

  return (
    <>
      <PageTitle title="Add Size - ALMOSTINVISIBLE" />
      <Layout>
        <h1 className="unbounded">Size</h1>
        <hr />
        <p className='unbounded fw-bold black-bordered-bottom'>Add Size</p>
        <form onSubmit={handleSubmit}>
          <div>
            <div className="flex-column">
              <label className='nunito-2'>Size Name*</label>
            </div>
            <div className="inputForm">
              <input
                type="text"
                value={sizeName}
                onChange={(e) => setSizeName(e.target.value)}
                required
                className="input"
                style={{ fontWeight: "bold" }}
                placeholder='Enter the name of the size you want to add'
              />
            </div>
            {error && <p className='error-message'>{error}</p>}
          </div>
          <br />
          <button type="submit" className='black-button'>Add Size</button>
        </form>

        <hr />
        <div className='container'>
          <p className='unbounded fw-bold black-bordered-bottom'>List Of Sizes</p>
          <ul>
            {sizes.map((size, index) => (
              <li key={size.id} className='d-flex justify-content-between my-2' style={{ padding: '10px', borderRadius: '5px' }}>
                <span>{index + 1}. {size.name}</span>
                <button className='red-button' onClick={() => handleDelete(size.id)}>
                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.5 5.5A.5.5 0 016 6v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm2.5 0a.5.5 0 01.5.5v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm3 .5a.5.5 0 00-1 0v6a.5.5 0 001 0V6z"></path>
                    <path fill-rule="evenodd" d="M14.5 3a1 1 0 01-1 1H13v9a2 2 0 01-2 2H5a2 2 0 01-2-2V4h-.5a1 1 0 01-1-1V2a1 1 0 011-1H6a1 1 0 011-1h2a1 1 0 011 1h3.5a1 1 0 011 1v1zM4.118 4L4 4.059V13a1 1 0 001 1h6a1 1 0 001-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" clip-rule="evenodd"></path>
                  </svg>
                  &nbsp; Delete
                </button>
              </li>
            ))}
          </ul>
        </div>
      </Layout>
    </>
  );
};

export default AddSizeForm;
